import { 
    ModalHeaderContainer, 
    ModalTitle, 
    CloseIconContainer, 
    ModalContentContainer, 
    ModalFooterContainer, 
    ActionButtonStyled,
    WarningMessage
} from './SharedModalComponents.styles';
import { VaultBulkEditCloseIcon } from '../../../assets/icons';

export const VaultModalHeader = ({ children, onClose }) => (
    <ModalHeaderContainer>
        <ModalTitle>
            {children}
        </ModalTitle>
        {onClose && (
            <CloseIconContainer onClick={onClose}>
                <VaultBulkEditCloseIcon />
            </CloseIconContainer>
        )}
    </ModalHeaderContainer>
);

export const VaultModalContent = ({ children }) => (
    <ModalContentContainer>
        {children}
    </ModalContentContainer>
);

export const VaultModalFooter = ({ children }) => (
    <ModalFooterContainer>
        {children}
    </ModalFooterContainer>
);

export const VaultActionButton = ({ children, onClick, backgroundColor, whiteText = true }) => (
    <ActionButtonStyled 
        backgroundColor={backgroundColor} 
        whiteText={whiteText} 
        onClick={onClick}
    >
        {children}
    </ActionButtonStyled>
);

export const VaultWarningMessage = ({ children }) => (
    <WarningMessage>
        {children}
    </WarningMessage>
); 